export const minDate = '0001-01-01T00:00:00';

export const timeFormat = 'HH:mm';

export const hour = 'hour';

export const russianLanguageId = 13;

export const dateFormatsListItems = [
	{
		// 07/22/2014
		id: 0,
		label: 'MM/DD/YYYY',
		format: 'MM/dd/yyyy',
		year: 'numeric',
		month: '2-digit',
		day: '2-digit'
	},
	{
		// 22/07/2014
		id: 1,
		label: 'DD/MM/YYYY',
		format: 'dd/MM/yyyy',
		year: 'numeric',
		month: '2-digit',
		day: '2-digit'
	},
	{
		// 2014/07/22
		id: 2,
		label: 'YYYY/MM/DD',
		format: 'yyyy/MM/dd',
		year: 'numeric',
		month: '2-digit',
		day: '2-digit'
	}
];

export const numberFormatsListItems = [
	{
		id: 0,
		locale: 'en-au',
		label: '1,234,567,890'
	},
	{
		id: 1,
		locale: 'en-in',
		label: '1,23,45,67,890'
	},
	{
		id: 2,
		locale: 'en-za',
		label: '1 234 567 890'
	},
	{
		id: 3,
		locale: 'pt-br',
		label: '1.234.567.890'
	}
];

export const displayLanguageListItems = [
	{
		id: 1,
		label: 'English',
		languageISOCode: 'eng'
	},
	{
		id: 4,
		label: 'Français (Canada)',
		languageISOCode: 'fre'
	},
	{
		id: 5,
		label: 'Español',
		languageISOCode: 'spa'
	},
	{
		id: 7,
		label: 'Português',
		languageISOCode: 'por'
	},
	{
		id: 8,
		label: '日本語',
		languageISOCode: 'jpn'
	},
	{
		id: 9,
		label: '简体中文',
		languageISOCode: 'zh-s'
	},
	{
		id: 10,
		label: '繁體中文',
		languageISOCode: 'zh-t'
	},
	{
		id: 12,
		label: '한국어',
		languageISOCode: 'kor'
	},
	{
		id: 13,
		label: 'Pусский',
		languageISOCode: 'rus'
	}
];
export const urls = {
	USERS_URL: 'users.json'
};

export const serviceURL = 'serviceUrl';
export const ENGAGEMENTMETADATA_URL = '/engagementmetadata.json';
export const WORKSPACE_URL = '/workspaces.json';
export const Entities = 'Entities';
export const TagContacts = 'TagContacts';
export const tags = 'tags';
export const projectTitle = 'Oversight';

export const numberFormats = [
	{value: '1,234,567,890', label: 'numbericStlye1', title: '1,234,567,890'},
	{value: '1.234.567.890', label: 'numbericStlye3', title: '1.234.567.890'},
	{value: '1,23,45,67,890', label: 'numbericStlye7', title: '1,23,45,67,890'},
	{value: '1 234 567 890', label: 'numbericStlye2', title: '1 234 567 890'}
];

export const showMoreMinLines = [
	{value: 1, label: 'showMoreMinLineOne'},
	{value: 2, label: 'showMoreMinLineTwo'},
	{value: 3, label: 'showMoreMinLineThree'},
	{value: 4, label: 'showMoreMinLineFour'},
	{value: 5, label: 'showMoreMinLineFive'},
	{value: 6, label: 'showMoreMinLineSix'}
];

export const defaultDateFormat = 0;

export const dateFormats = [
	{value: 'MM/dd/yyyy', id: 0, label: 'MM/DD/YYYY'},
	{value: 'dd/MM/yyyy', id: 1, label: 'DD/MM/YYYY'},
	{value: 'yyyy/MM/dd', id: 2, label: 'YYYY/MM/DD'}
];

export const displayLanguages = [
	{displayLanguageId: 1, label: 'English', value: 'en-us'},
	{displayLanguageId: 4, label: 'Français', value: 'fr-ca'},
	{displayLanguageId: 5, label: 'Español', value: 'es'},
	{displayLanguageId: 7, label: 'Português', value: 'pt-br'},
	{displayLanguageId: 8, label: '日本語', value: 'ja'},
	{displayLanguageId: 9, label: '简体中文', value: 'zh-cn'},
	{displayLanguageId: 10, label: '繝體中文', value: 'zh-tw'},
	{displayLanguageId: 11, label: 'עברית', value: 'he'},
	{displayLanguageId: 12, label: '한국어', value: 'ko'},
	{displayLanguageId: 13, label: 'Pуѝѝкий', value: 'ru'},
	{displayLanguageId: 14, label: 'عربى', value: 'ar'}
];

export const minorErrorCodes = [1001];

export const keyCode = {
	CANCEL: 3,
	HELP: 6,
	BACK_SPACE: 8,
	TAB: 9,
	CLEAR: 12,
	RETURN: 13,
	ENTER: 13,
	SHIFT: 16,
	CONTROL: 17,
	ALT: 18,
	PAUSE: 19,
	CAPS_LOCK: 20,
	ESCAPE: 27,
	SPACE: 32,
	PAGE_UP: 33,
	PAGE_DOWN: 34,
	END: 35,
	HOME: 36,
	ARROWLEFT: 37,
	ARROWUP: 38,
	ARROWRIGHT: 39,
	ARROWDOWN: 40,
	PRINTSCREEN: 44,
	INSERT: 45,
	DELETE: 46,
	KEY_0: 48,
	KEY_1: 49,
	KEY_2: 50,
	KEY_3: 51,
	KEY_4: 52,
	KEY_5: 53,
	KEY_6: 54,
	KEY_7: 55,
	KEY_8: 56,
	KEY_9: 57,
	SEMICOLON: 59,
	EQUALS: 61,
	KEY_A: 65,
	KEY_B: 66,
	KEY_C: 67,
	KEY_D: 68,
	KEY_E: 69,
	KEY_F: 70,
	KEY_G: 71,
	KEY_H: 72,
	KEY_I: 73,
	KEY_J: 74,
	KEY_K: 75,
	KEY_L: 76,
	KEY_M: 77,
	KEY_N: 78,
	KEY_O: 79,
	KEY_P: 80,
	KEY_Q: 81,
	KEY_R: 82,
	KEY_S: 83,
	KEY_T: 84,
	KEY_U: 85,
	KEY_V: 86,
	KEY_W: 87,
	KEY_X: 88,
	KEY_Y: 89,
	KEY_Z: 90,
	CONTEXT_MENU: 93,
	NUMPAD0: 96,
	NUMPAD1: 97,
	NUMPAD2: 98,
	NUMPAD3: 99,
	NUMPAD4: 100,
	NUMPAD5: 101,
	NUMPAD6: 102,
	NUMPAD7: 103,
	NUMPAD8: 104,
	NUMPAD9: 105,
	MULTIPLY: 106,
	ADD: 107,
	SEPARATOR: 108,
	SUBTRACT: 109,
	DECIMAL: 110,
	DIVIDE: 111,
	F1: 112,
	F2: 113,
	F3: 114,
	F4: 115,
	F5: 116,
	F6: 117,
	F7: 118,
	F8: 119,
	F9: 120,
	F10: 121,
	F11: 122,
	F12: 123,
	F13: 124,
	F14: 125,
	F15: 126,
	F16: 127,
	F17: 128,
	F18: 129,
	F19: 130,
	F20: 131,
	F21: 132,
	F22: 133,
	F23: 134,
	F24: 135,
	NUM_LOCK: 144,
	SCROLL_LOCK: 145,
	COMMA: 188,
	PERIOD: 190,
	SLASH: 191,
	BACK_QUOTE: 192,
	OPEN_BRACKET: 219,
	BACK_SLASH: 220,
	CLOSE_BRACKET: 221,
	QUOTE: 222,
	META: 224
};

export const routes = {
	clients: {
		root: 'clients'
	},
	contacts: {
		root: 'contacts'
	},
	dashboard: {
		root: 'dashboard'
	},
	gra: {
		root: 'groupriskassessment'
	},
	project: {
		root: 'projects',
		classic: 'project',
		gra: 'gra',
		engagementMetrics: 'engagementmetrics',
		clientPortalMetrics: 'clientPortalMetrics',
		groupAuditMetrics: 'groupAuditMetrics',
		insightMetrics: 'insightMetrics',
		milestoneMetrics: 'milestoneMetrics',
		projectManagementMetrics: 'projectManagementMetrics',
		reportMetrics: 'reportMetrics',
		groupRiskAssessment: 'groupRiskAssessment'
	},
	users: {
		root: 'users',
		me: 'me'
	},
	usersettings: {
		root: 'usersettings'
	},
	queryString: {
		expand: 'expand',
		projectId: 'projectId'
	}
};

/*This object hold area information to track on-going promises. used in react-promise-tracker*/
export const promiseAreas = {
	MILESTONE_DETAILS_AREA: 'MILESTONE_DETAILS_AREA',
	QUICK_LINK_AREA: 'QUICK_LINK_AREA',
	REVIEWNOTE_SUMMARY_AREA: 'REVIEWNOTE_SUMMARY_AREA',
	USERROLE_SELECTION_AREA: 'USERROLE_SELECTION_AREA',
	TASK_LIST_AREA: 'TASK_LIST_AREA',
	ENGAGEMENT_METRICS_AREA: 'ENGAGEMENT_METRICS_AREA',
	TASK_DETAILS_AREA: 'TASK_DETAILS_AREA',
	GROUP_AUDIT_TASK_AREA: 'GROUP_AUDIT_TASK_AREA',
	BUILD_TASK_LIST: 'BUILD_TASK_LIST',
	USER_SETTINGS_AREA: 'USER_SETTINGS_AREA',
	DELEGATE_AREA: 'DELEGATE_AREA',
	GET_PROJECT_GROUPS_AREA: 'GET_PROJECT_GROUPS_AREA',
	GET_PROJECT_ENTITIES_AREA: 'GET_PROJECT_ENTITIES_AREA',
	GET_PROJECT_DETAILS_AREA: 'GET_PROJECT_DETAILS_AREA',
	COPY_GROUP_AREA: 'COPY_GROUP_AREA',
	ACCESS_GROUP_AREA: 'ACCESS_GROUP_AREA',
	USER_PROJECTS_AREA: 'USER_PROJECTS_AREA',
	OTHER_PROJECTS_AREA: 'OTHER_PROJECTS_AREA',
	GET_MANAGE_USER: 'GET_MANAGE_USER',
	GET_ADMIN_USERS: 'GET_ADMIN_USERS',
	CREATE_ADMIN_USER: 'CREATE_ADMIN_USER',
	DELETE_PROJECT_GROUP_USER_MEMBER: 'DELETE_PROJECT_GROUP_USER_MEMBER',
	ADD_MEMBER_TO_GROUP: 'ADD_MEMBER_TO_GROUP',
	PAANS_AREA: 'PAANS_AREA'
};

/*Enum for Document Type complete list*/
export const documentTypes = {
	UNDEFINED: 0,
	EVIDENCEDOCUMENT: 1,
	CRASHDOCUMENT: 2,
	PRIORYEAREVIDENCEDOCUMENT: 3,
	CLIENTFILESDOCUMENT: 4,
	SNAPSHOTDOCUMENT: 5,
	SMARTFORMDOCUMENT: 6,
	EVIDENCE: 7,
	CRASH: 8,
	PRIORYEAREVIDENCE: 9,
	CLIENTFILES: 10,
	SNAPSHOT: 11,
	PROFILE: 12,
	KEYRISKIDENTIFICATION: 13,
	KEYRISKIDENTIFICATIONUBT: 14,
	ENTITYLEVELCONTROLSSUMMARY: 15,
	MANAGEMENTPROCEDURESSUMMARY: 16,
	DETERMINEPMTESAD: 17,
	ACCOUNTSSUMMARY: 18,
	SCOTSSUMMARY: 19,
	ITSOSUMMARY: 20,
	CRASUMMARY: 21,
	AUDITPLAN: 22,
	EVALUATEAUDITRESULTS: 23,
	CONFIRMFINALMATERIALITY: 24,
	SUMMARYOFAUDITDIFFERENCES: 25,
	ACCOUNTCONCLUSIONCLASSIC: 26,
	LEADSCHEDULE: 27,
	ARCHIVE: 28,
	PAPERPROFILEDOCUMENT: 29,
	PAPERPROFILE: 30,
	GROUPAUDITSTRUCTURESUMMARY: 31,
	GROUPAUDITINSTRUCTIONSUMMARY: 32,
	GROUPCOMPONENTINSTRUCTIONDOCUMENT: 33,
	OARINTERIMCOMPARISON: 34,
	OARCURRENTYEARCOMPARISON: 35,
	GROUPCOMPONENTSUMMARYDOCUMENT: 36,
	RETURNEDDOCUMENT: 37,
	WORKPLANSUMMARY: 38,
	TIEOUT: 39,
	LEADSCHEDULETEMPORARYSMARTFORM: 40,
	OARINTERIMCOMPARISONTEMPORARYSMARTFORM: 41,
	OARCURRENTYEARCOMPARISONTEMPORARYSMARTFORM: 42,
	TIEOUTTEMPORARYSMARTFORM: 43,
	EYSENTTOCLIENTFILES: 44,
	ITEVALUATIONSMARTFORM: 45,
	ITEVALUATIONTEMPORARYSMARTFORM: 46,
	BULKDOCUMENTEXPORT: 47,
	CANVASFORM: 48,
	CANVASFORMEVIDENCE: 49,
	CANVASFORMTEMPORARY: 50,
	AUTOMATIONPARENT: 51,
	AUTOMATIONHUBINPUT: 52,
	AUTOMATIONHUBOUTPUT: 53,
	CONTROLFORM: 54,
	INDEPENDENCEFORMTEMPLATE: 56,
	EVIDENCENOTDISPLAYED: 57,
	INDEPENDENCEFORMINDIVIDUAL: 58,
	SEM: 69,
	ACCOUNT_CONCLUSION: 70,
	FOUR_FORTY_GL: 71
};

export const formBodyType = {
	KnowledgeOnly: 1,
	TextResponse: 2,
	ToggleTwoButton: 3,
	ToggleThreeButton: 4,
	DropDownList: 5,
	RadioButton: 6,
	CheckBox: 7,
	RelatedWCGWsSCOTs: 8,
	NumericTextBox: 9,
	RelatedRisks: 10,
	DatePicker: 11,
	RelatedITRiskITProcess: 12,
	RelatedITApps: 13,
	WCGWTasks: 14
};

export const numericValueRegex = /(^[0-9]+$|^$)/;

export const accountDesignations = {
	significantAccount: 1,
	limitedRiskAccount: 2,
	insignificantAccount: 3,
	otherAccount: 4,
	significantDisclosure: 5
};

export const assertionOrder = ['C', 'E/O', 'M/V', 'R&O', 'P&D'];

export const assertionsList = [
	{abbreviation: 'C', ids: [3, 8, 10]},
	{abbreviation: 'E/O', ids: [11]},
	{abbreviation: 'M/V', ids: [12]},
	{abbreviation: 'R&O', ids: [4, 13]},
	{abbreviation: 'P&D', ids: [5, 9, 14]}
];

export const inherentRiskTypes = {
	1: 'H',
	2: 'L'
};

export const TaskTypeEnum = {
	CONTROL_TASK: 1,
	CONTROL_TASK_CONTROL: 2,
	CONTROL_TASK_ELC: 3,
	CONTROL_TASK_ITSO: 4,
	CONTROL_TASK_MP: 5,
	CONTROL_TASK_SO: 6,
	RESPONSE_TASK: 7,
	CASHFLOW_MISSTATEMENT_RESPONSE_TASK: 8,
	DEFICIENCY_RESPONSE_TASK: 9,
	DISCLOSURE_MISSTATEMENT_RESPONSE_TASK: 10,
	MISSTATEMENT_RESPONSE_TASK: 11,
	STANDARD_TASK: 12,
	OTHER_STANDARD_TASK: 13,
	PRIMARY_STANDARD_TASK: 14,
	SUBSTANTIVE_TASK: 15,
	OTHER_SUBSTANTIVE_PROCEDURE_TASK: 16,
	PRIMARY_SUBSTANTIVE_PROCEDURE_TASK: 17,
	WALKTHROUGH_TASK: 18,
	WALKTHROUGH_TASK_ITSO: 19,
	WALKTHROUGH_TASK_SCOT: 20,
	TODO: 21,
	ACCOUNT_CONCLUSION_TASK: 22,
	GROUP_TASK: 23,
	PRIMARY_GROUP_TASK: 24,
	COMPONENT_GROUP_TASK: 25,
	ITSO_OTHER_SUBSTANTIVE_PROCEDURE_TASK: 26,
	COMPONENT_GROUP_TASK_UNLINKED: 27
};

export const taskSourceType = {
	Internal: 1,
	External: 2
};

export const taskNatureType = {
	TestOfDetail: 1,
	SubstantiveAnalyticalProcedure: 2,
	TestOfControl: 3
};
export const taskApiRoutes = {
	task: 'tasks/',
	category: 'TaskCategories/',
	engagement: 'Engagements/',
	workspace: 'Workspace/',
	relatedWCGWs: 'tasks/?expandRelatedWCGW=true',
	annotation: 'Annotations/',
	document: 'Documents/'
};

export const ValidationGroup = {
	ArchiveTimelineFinalizeEvidence: 10001,
	ArchiveTimelineCompleteRemainingTasks: 10002,
	ArchiveTimelineResolveValidations: 10003,
	AccountConclusion: 10004,
	SubstantiveEvaluationMatrix: 10005,
	FourFortyGl: 10006,
	RiskWithNoRelatedSubstantiveTask: 10007,
	RiskWithNoRelatedWcgw: 10008,
	DashboardScopeAndStrategy: 10009,
	DashboardExecution: 10010,
	DashboardConclusion: 10011
};
export const reviewNotesType = {
	task: 1,
	document: 2
};
export const accountConclusionTabs = {
	conclusions: 'conclusions'
};
export const entityTypes = {
	Engagement: 'engagement',
	Task: 'task',
	Document: 'document',
	openReviewNoteCount: 'opennotescount'
};
export const entities = {
	all: 0,
	Document: 1,
	LeadSchedule: 2,
	Account: 3,
	SCOT: 4,
	ItProcess: 5,
	AuditPlan: 6,
	Risk: 7,
	Task: 8,
	Misstatement: 9,
	Deficiency: 10,
	GaComponent: 11,
	GaComponentInstruction: 12,
	GaComponentEvidence: 13,
	GaScope: 14,
	GaPrimaryInstruction: 15,
	GaPrimary: 16,
	ClientRequest: 17,
	WCGW: 18,
	Control: 19,
	IsSoApplication: 20,
	CanvasForm: 21,
	FormSection: 22,
	FormBody: 23,
	Assertion: 24,
	ClientEngagement: 25,
	ClientGroup: 26,
	EngagementTag: 27,
	Engagement: 28,
	FormHeader: 29,
	FormStatus: 30,
	EngagementUser: 31,
	ClientGroupUser: 32,
	PspIndex: 33,
	ItControl: 34,
	ItRisk: 35,
	AutomationLineItem: 36
};

export const taskBuildMilestoneIds = {
	WCGWTask: 29,
	RiskWCGW: 30
};

export const EditAssociationTabVal = {
	RISK_WCGW: 'riskwcgw',
	WCGW_TASK: 'wcgwtask'
};
export const TaskCategory = {
	my: 1,
	all: 2,
	sas: 3,
	scot: 4,
	itso: 5,
	account: 6,
	execution: 7,
	conclusion: 8,
	teamsummary: 9
};
export const TaskSubCategory = {
	all: 1,
	preparer: 2,
	reviewer: 3
};
export const auditPhases = {
	viewAll: 0,
	scopeAndStrategy: 1,
	execution: 2,
	conclusionAndWrapup: 3
};
export const TaskTypeEnumForAddTask = {
	ImportedFromKnowledge: 14,
	Custom: 13,
	Account: 16,
	ITSubstantive: 26,
	WalkthroughTask: 20,
	ControlTask: 2,
	ITWalkthroughTask: 19,
	ITControlTask: 4
};
export const validationTypes = {
	IndependenceCompliance: 1,
	IndependenceFormversionNotCurrent: 2,
	UserAccessTobeReviewed: 3,
	OverrideByIneligibleRole: 4,
	UnrelatedSCOTs: 5,
	UnrelatedControls: 6,
	ControlsStrategySelectedWithNoRelatedWCGWs: 7,
	ControlSstrategySelectedWithNoRelatedControls: 8,
	ControlsStrategySelectedWithNoRelatedControlSelectedForTesting: 9,
	ControlsstrategyselectedandthereisaWCGWwithnorelatedControlsSelectedForTesting: 10 /*seriously*/,
	UnrelatedRisks: 11,
	CompleteCRAforThisAssertion: 12,
	UnrelatedWCGWs: 13,
	SignificantAccountHasNorelatedSCOTs: 14,
	RelystrategySelectedWithNoRelatedWCGWs: 15,
	RelystrategySelectedWithNoRelatedControls: 16,
	RelystrategySelectedWithNoRelatedControlsSelectedForTesting: 17,
	RelystrategySelectedAndThereisaWCGWwithnorelatedControlsSelectedForTesting: 18,
	ITSummary: 19,
	ConfirmAccuracyOfAuditorReport: 20,
	CompleteArchiveForm: 21,
	CompleteArchiveTask: 22,
	UnlinkGroupSharedEvidence: 23,
	NorelatedControlsITSubstantiveProceduresSelectedForTesting: 24,
	ThereisaRiskWithNorelatedControlsITSubstantiveProceduresSelectedForTesting: 25,
	AuditPlan: 26,
	NoSubstantiveTasksareRelatedtotheAssertion: 27,
	UnrelatedTOC: 28,
	UnrelatedWalkthrough: 29,
	NoWalkthroughTasksAreRelatedtotheSCOT: 30,
	NoControlTasksareRelatedtoaControlSelectedForTesting: 31,
	UnrelatedITSOWalkthrough: 32,
	UnrelatedITSOTOC: 33,
	UnrelatedITSOOSP: 34,
	TheITSOProcessDoesNotHaveaRelatedWalkthroughtask: 35,
	AControlDoesNotHaveaRelated: 36,
	AITSubstantiveProcedureDoesNotHaveaRelatedOSP: 37,
	RemainingDocumentConflicts: 38,
	SyncConflictSharedEvidenceNotDisplayedinCanvasValidationCount: 39,
	SignoffOnAllEvidence: 40,
	AddEvidenceToTaskWithoutEvidence: 41,
	InvalidEngagementCode: 42,
	InvalidClientCode: 43,
	DuplicateFileNames: 44,
	ITEvaluation: 45,
	InconsistentITEvaluations: 46,
	IncompleteAggregateITEvaluation: 47,
	ResponseIncomplete: 48,
	UnassociateFinding: 49,
	UnassociatedDeficiency: 50,
	SubstantiveEvaluationMatrix: 51,
	CRASummary: 52,
	AccountsSummary: 53,
	SCOTsSummary: 54,
	EstimateSCOTwithoutEstimateAccount: 55,
	AssertionwithcontrolriskofrelywithoutaresponsiveTOC: 56,
	AssertionWithControlRiskofrelyWithoutAtleastoneResponsive: 57,
	AssertionWithoutResponsiveSubstantiveTask: 58,
	AssertionWithoutaResponsiveControl: 59,
	CanvasFromComments: 60,
	FinalizeIncompleteCanvasFromResponses: 61,
	AddressOpenReviewNotes: 62,
	RemoveTrackChangesFromEvidence: 63,
	MarkTasksComplete: 64,
	UnlinkSharedEvidence: 65,
	DocumentsWithoutModificationType: 66,
	NonAdminChangesWithoutChangeReason: 67,
	UnapprovedModificationsForNonAdminChangesByAppropriateRole: 68,
	FourFortyMissingExecReviewerSignOff: 69
};

export const ValidationSubGroupsForDashboard = {
	IndependenceCompliance: 9008,
	AccoutSummary: 9001,
	ScotSummary: 9002,
	ItSummary: 9004,
	CraSummary: 9003,
	AuditPlan: 9005,
	SubstantiveEvaluationMatrix: 51,
	ValidationsByCanvasForm: 9012,
	ITEvaluation: 9009,
	UnrelatedMisstatements: 49,
	UnrelatedDeficiencies: 50,
	DuplicateFileNames: 44,
	UnresolvedConflicts: 38,
	ModificationsAfterTheReportReleaseDate: 9013
};

export const clientSideEventNames = {
	onRailChange: 'onRailChange',
	onFormChange: 'onFormChange',
	railSectionChange: 'railSectionChange',
	setSelectedAssertionName: 'setSelectedAssertionName',
	getScotsForAssertion: 'getScotsForAssertion',
	resize: 'resize',
	updateHeaderValidations: 'updateHeaderValidations',
	updateSectionValidations: 'updateSectionValidations',
	updateBodyValidations: 'updateBodyValidations',
	getContentUpdateHistoryFromAPI: 'getContentUpdateHistoryFromAPI'
};

export const HttpStatusCodes = {
	Ok: 200,
	Created: 201,
	NoContent: 204,
	Unauthorized: 401,
	Forbidden: 403,
	NotFound: 404,
	Conflict: 409,
	PreConditionFailed: 412,
	RequestEntityTooLarge: 413,
	BadRequest: 400,
	InternalServerError: 500
};

export const wcgwApiRoutes = {
	wcgws: 'wcgws',
	associateTask: 'wcgws/{wcgwId}/tasks',
	unassociateTask: 'wcgws/{wcgwId}/tasks/{taskId}'
};

export const reviewNoteStatus = {
	Open: {id: 1, value: 'open'},
	Closed: {id: 2, value: 'closed'},
	Cleared: {id: 5, value: 'cleared'}
};

export const rnhEngagementSources = {
	currentEngagement: 1,
	otherEngagement: 2,
	allEngagements: 3
};

export const tabsUniqueConstants = {
	documentReviewNotes: 'documentReviewNotes',
	taskReviewNotes: 'taskReviewNotes',
	allNotes: 'allNotes',
	myNotes: 'myNotes',
	relateEvidence: 'relateEvidence',
	createPaperProfile: 'createPaperProfile',
	internalMember: 'internalMember',
	externalMember: 'externalMember',
	otherEngagementNotes: 'otherEngagementNotes'
};

export const projectDetailExpandOptions = {
	clients: 'clients',
	users: 'users',
	engagements: 'engagements'
};

export const metricsTileLabelType = {
	fraction: 1,
	outOf: 2
};

export const UserLookupType = {
	NotSpecified: 0,
	Internal: 1,
	External: 2,
	ThirdPartyUser: 3,
	Admin: 4
};

export const projectStatusEnum = {
	INITIAL: 'initial',
	DRAFT: 'draft',
	ACTIVE: 'active',
	CANCELLED: 'cancelled',
	COMPLETED: 'completed',
	DELETE: 'delete'
};

export const milestonesFilterId = {
	milestones: 1,
	keyEvents: 2
};

export const reportingFilterId = {
	completionByEngagement: 1,
	completionByLocation: 2,
	opinionType: 3
};

export const insightFilterId = {
	risks: 1,
	strategy: 2,
	findings: 3
};

export const insightTypes = {
	risk: 'risk',
	digitalAudit: 'digitalAudit',
	auditstrategy: 'auditstrategy',
	finding: 'finding'
};

export const UserType = {
	Member: 'Member',
	Guest: 'Guest'
};

export const entityAdmin = 'entityAdmin';
export const projectOwner = 'projectOwner';
export const userContact = 'user';

export const rootEntityId = '1';
export const rootLevelId = 1;
export const notApplicableId = 999;

export const DefautAddGroupRoles = ['admin'];
export const DefautAddGroupRolesInternalUsers = ['admin', 'owner'];
export const AdminGroupRoles = ['admin'];

export const DefautAddGroupRolesExternalUsers = ['admin'];

export const AdminRoles = [
	{key: 'IsAdminReader', value: 'IsAdminReader', id: 1},
	{key: 'IsAdminWriter', value: 'IsAdminWriter', id: 2},
	{key: 'IsSuperAdmin', value: 'IsSuperAdmin', id: 3}
];

export const ProjectStatus = [
	{value: 'initial', id: 1},
	{value: 'draft', id: 2},
	{value: 'active', id: 3},
	{value: 'cancelled', id: 4},
	{value: 'completed', id: 5},
	{value: 'delete', id: 6}
];

export const manageTeamsSections = {
	teamMembers: 1,
	eyContacts: 2
};

export const messageType = {
	filters: 'filters',
	bulk: 'bulk',
	duplicate: 'duplicate'
};
export const MessageSend = {
	Notification: 'Notification',
	Email: 'Email'
};

export const MessageTypeLog = {
	Email: 1,
	Notifcation: 2
};

export const generateMessageFilter = {
	contacts: 'contacts',
	entities: 'entities',
	countries: 'countries',
	groupRole: 'groupRole',
	engagements: 'engagements',
	serviceLine: 'serviceLine',
	roles: 'roles'
};
export const allElements = 'all';
export const allMembersKey = 'all';
export const internalMembersKey = 'internal';
export const externalMembersKey = 'external';

export const ViewMemberType = {
	Internal: 1,
	External: 2,
	AllMember: 3
};

export const maxNodeAllowedAtAnyLevel = 20;

export const daySelection = {
	tomorrow: 1,
	next3days: 2,
	next5days: 3,
	next10days: 4,
	next30days: 5
};

export const roles = {
	partnerInCharge: 1,
	engagementPartner: 2,
	executiveDirector: 3,
	principal: 4,
	seniorManager: 5,
	manager: 6,
	senior: 7,
	staff: 8,
	intern: 9,
	engagementQualityReviewer: 10,
	otherPartner: 11,
	gdsStaff: 12,
	advisory: 13,
	tax: 14,
	executiveSupportServices: 15,
	generalCounsel: 16,
	auditQualityReviewer: 17,
	mlComponentTeam: 18,
	clientSupervisor: 19,
	clientStaff: 20,
	internalAuditSupervisor: 21,
	internalAuditStaff: 22,
	regulator: 23,
	other: 24,
	office: 25,
	area: 26,
	industry: 27,
	national: 28,
	global: 29,
	gsdSenior: 30,
	gsdManager: 31
};

export const oversightTabs = {
	activeProjects: 'activeProjects',
	completedProjects: 'completedProjects',
	otherProjects: 'otherProjects'
};

export const adminUserTabs = {
	accessibleProjects: 'accessibleProjects',
	otherProjects: 'otherProjects',
	clients: 'clients',
	delegates: 'delegates',
	userSettings: 'userSettings'
};

export const manageProjectTabs = {
	clients: 'clients',
	orgChartEntities: 'orgChartEntities',
	connectedEngagements: 'connectedEngagements',
	groups: 'groups',
	projectOwners: 'projectOwners'
};

export const delegateTabs = {
	delegateTo: 'delegateTo',
	delegateFrom: 'delegateFrom'
};

export const createProjectSteps = {
	selectClient: 1,
	createOrgChart: 2,
	connectToEYCanvas: 3,
	createGroups: 4
};

export const createProjectStepsIndex = {
	selectClient: 0,
	createOrgChart: 1,
	connectToEYCanvas: 2,
	viewSummary: 3,
	createGroups: 4
};

export const GARoleTypeId = {
	Primary: 1,
	Region: 2,
	Component: 3
};

export const archiveReportQualifiedTypeId = {
	notSelected: 0,
	unqualifiedWithEmphasisOfMatter: 1,
	unqualifiedWithoutEmphasisOfMatter: 2,
	qualifiedWithEmphasisOfMatter: 3,
	qualifiedWithoutEmphasisOfMatter: 4,
	adverseOpinionWithEmphasisOfMatter: 5,
	adverseOpinionWithoutEmphasisOfMatter: 6,
	disclaimerOfOpinionWithEmphasisOfMatter: 7,
	disclaimerOfOpinionWithoutEmphasisOfMatter: 8
};

export const AuditInsightViewType = {
	groupRole: 1,
	all: 2
};

export const EngagementDataViewType = {
	primary: 1,
	regionalAndComponent: 2
};

export const findingType = {
	misstatement: 1,
	deficiency: 2
};
export const riskType = {
	risk: 1
};

export const auditStrategyType = {
	substantiveprocedures: 1,
	controls: 2,
	it: 3
};

export const digitalAuditType = {
	digitalAudit: 1
};

export const ProfileDigitalGAMType = {
	yes: 348,
	no: 349
};

export const arcReport = {
	yes: 1,
	no: 2,
	notApplicable: 3
};
export const arcReportType = {
	unqualifiedEoM: 1,
	unqualified: 2,
	qualifiedEoM: 3,
	qualified: 4,
	adverseEoM: 5,
	adverse: 6,
	disclaimerEoM: 7,
	disclaimer: 8
};

export const toggleCCPEntityDetail = {
	comingDue: 1,
	overdue: 2,
	returned: 3
};

export const ccpMetricStatus = {
	acceptedReceived: 1,
	returnedOutstanding: 2,
	overdueOutstandingAverageDaySum: 3
};

export const userTheme = {
	dark: 'dark',
	light: 'light'
};

export const dashboardTabId = {
	milestones: 1,
	projectManagement: 2,
	groupAudit: 3,
	insights: 4,
	reporting: 5,
	canvasClientPortal: 6
};

export const groupRiskAssessmentTabId = {
	activityFeed: 1,
	reconciliations: 2
};

export const readinessReportCategories = {
	comingDueOver2Weeks: 0,
	comingDue12Weeks: 1,
	comingDueUnder1Week: 2,
	overDueUnder1Week: 3,
	overDue12Weeks: 4,
	overDueOver2Weeks: 5
};

export const dashboardChartColors = {
	green: {
		0: 'var(--neutrals-200)',
		1: 'var(--green-300)',
		2: 'var(--green-500)',
		3: 'var(--green-700)'
	},
	orange: {
		0: 'var(--neutrals-200)',
		1: 'var(--orange-200)',
		2: 'var(--orange-300)',
		3: 'var(--orange-500)'
	},
	blue: {
		0: 'var(--neutrals-200)',
		1: 'var(--blue-300)',
		2: 'var(--blue-400)',
		3: 'var(--blue-600)',
		4: 'var(--blue-800)'
	},
	teal: {
		0: 'var(--neutrals-200)',
		1: 'var(--teal-200)',
		2: 'var(--teal-300)',
		3: 'var(--teal-500)'
	},
	red: {
		0: 'var(--neutrals-200)',
		1: 'var(--red-300)',
		2: 'var(--red-500)',
		3: 'var(--red-700)'
	},
	maroon: {
		0: 'var(--neutrals-200)',
		1: 'var(--maroon-200)',
		2: 'var(--maroon-400)',
		3: 'var(--maroon-600)'
	},
	purple: {
		0: 'var(--neutrals-200)',
		1: 'var(--purple-200)',
		2: 'var(--purple-300)',
		3: 'var(--purple-500)',
		4: 'var(--purple-700)'
	},
	brand: {
		0: 'var(--neutrals-200)',
		1: 'var(--neutrals-600)',
		2: 'var(--brand-500)'
	}
};

export const reportingBuckets = [
	{
		name: '0%',
		commingDueColor: dashboardChartColors.teal[0],
		overDueColor: dashboardChartColors.red[0],
		min: 0,
		max: 0
	},
	{
		name: '1-49%',
		commingDueColor: dashboardChartColors.teal[1],
		overDueColor: dashboardChartColors.red[1],
		min: 1,
		max: 49
	},
	{
		name: '50-79%',
		commingDueColor: dashboardChartColors.teal[2],
		overDueColor: dashboardChartColors.red[2],
		min: 50,
		max: 79
	},
	{
		name: '>80%',
		commingDueColor: dashboardChartColors.teal[3],
		overDueColor: dashboardChartColors.red[3],
		min: 80,
		max: 100
	}
];

export const engagementStatus = {
	archived: 0,
	active: 1
};

export const engagementStatuses = {
	Active: 'Active',
	Archived: 'Archived',
	Restored: 'Restored',
	MarkedForDeletion: 'Marked For Deletion'
};

export const gaasCountries = [
	{profileAnswerOptionValue: 'International Standards on Auditing (ISA)', profileAnswerOptionId: 5},
	{profileAnswerOptionValue: 'Afghanistan', profileAnswerOptionId: 6},
	{profileAnswerOptionValue: 'Albania', profileAnswerOptionId: 7},
	{profileAnswerOptionValue: 'Algeria', profileAnswerOptionId: 8},
	{profileAnswerOptionValue: 'Angola', profileAnswerOptionId: 9},
	{profileAnswerOptionValue: 'Argentina', profileAnswerOptionId: 10},
	{profileAnswerOptionValue: 'Armenia', profileAnswerOptionId: 11},
	{profileAnswerOptionValue: 'Aruba', profileAnswerOptionId: 12},
	{profileAnswerOptionValue: 'Australia', profileAnswerOptionId: 13},
	{profileAnswerOptionValue: 'Austria', profileAnswerOptionId: 14},
	{profileAnswerOptionValue: 'Azerbaijan', profileAnswerOptionId: 15},
	{profileAnswerOptionValue: 'Bahamas', profileAnswerOptionId: 16},
	{profileAnswerOptionValue: 'Bahrain', profileAnswerOptionId: 17},
	{profileAnswerOptionValue: 'Bangladesh', profileAnswerOptionId: 18},
	{profileAnswerOptionValue: 'Barbados', profileAnswerOptionId: 19},
	{profileAnswerOptionValue: 'Belarus', profileAnswerOptionId: 20},
	{profileAnswerOptionValue: 'Belgium', profileAnswerOptionId: 21},
	{profileAnswerOptionValue: 'Bermuda', profileAnswerOptionId: 22},
	{profileAnswerOptionValue: 'Bolivia', profileAnswerOptionId: 23},
	{profileAnswerOptionValue: 'Botswana', profileAnswerOptionId: 24},
	{profileAnswerOptionValue: 'Brazil', profileAnswerOptionId: 25},
	{profileAnswerOptionValue: 'British Virgin Islands', profileAnswerOptionId: 26},
	{profileAnswerOptionValue: 'Brunei', profileAnswerOptionId: 27},
	{profileAnswerOptionValue: 'Bulgaria', profileAnswerOptionId: 28},
	{profileAnswerOptionValue: 'Cambodia', profileAnswerOptionId: 29},
	{profileAnswerOptionValue: 'Cameroon', profileAnswerOptionId: 30},
	{profileAnswerOptionValue: 'Canada', profileAnswerOptionId: 31},
	{profileAnswerOptionValue: 'Cayman Islands', profileAnswerOptionId: 32},
	{profileAnswerOptionValue: 'Chad', profileAnswerOptionId: 33},
	{profileAnswerOptionValue: 'Chile', profileAnswerOptionId: 34},
	{profileAnswerOptionValue: 'China', profileAnswerOptionId: 35},
	{profileAnswerOptionValue: 'Colombia', profileAnswerOptionId: 36},
	{profileAnswerOptionValue: 'Congo', profileAnswerOptionId: 37},
	{profileAnswerOptionValue: 'Congo,The Democratic Republic of the', profileAnswerOptionId: 38},
	{profileAnswerOptionValue: 'Costa Rica', profileAnswerOptionId: 39},
	{profileAnswerOptionValue: 'Croatia', profileAnswerOptionId: 40},
	{profileAnswerOptionValue: 'Curacao', profileAnswerOptionId: 41},
	{profileAnswerOptionValue: 'Cyprus', profileAnswerOptionId: 42},
	{profileAnswerOptionValue: 'Czech Republic', profileAnswerOptionId: 43},
	{profileAnswerOptionValue: 'Denmark', profileAnswerOptionId: 44},
	{profileAnswerOptionValue: 'Dominican Republic', profileAnswerOptionId: 45},
	{profileAnswerOptionValue: 'Ecuador', profileAnswerOptionId: 46},
	{profileAnswerOptionValue: 'Egypt', profileAnswerOptionId: 47},
	{profileAnswerOptionValue: 'El Salvador', profileAnswerOptionId: 48},
	{profileAnswerOptionValue: 'Equatorial Guinea', profileAnswerOptionId: 49},
	{profileAnswerOptionValue: 'Estonia', profileAnswerOptionId: 50},
	{profileAnswerOptionValue: 'Ethiopia', profileAnswerOptionId: 51},
	{profileAnswerOptionValue: 'Fiji', profileAnswerOptionId: 52},
	{profileAnswerOptionValue: 'Finland', profileAnswerOptionId: 53},
	{profileAnswerOptionValue: 'France', profileAnswerOptionId: 54},
	{profileAnswerOptionValue: 'Gabon', profileAnswerOptionId: 55},
	{profileAnswerOptionValue: 'Georgia', profileAnswerOptionId: 56},
	{profileAnswerOptionValue: 'Germany', profileAnswerOptionId: 57},
	{profileAnswerOptionValue: 'Ghana', profileAnswerOptionId: 58},
	{profileAnswerOptionValue: 'Greece', profileAnswerOptionId: 59},
	{profileAnswerOptionValue: 'Guam', profileAnswerOptionId: 60},
	{profileAnswerOptionValue: 'Guatemala', profileAnswerOptionId: 61},
	{profileAnswerOptionValue: 'Guernsey', profileAnswerOptionId: 62},
	{profileAnswerOptionValue: 'Guinea', profileAnswerOptionId: 63},
	{profileAnswerOptionValue: 'Honduras', profileAnswerOptionId: 64},
	{profileAnswerOptionValue: 'Hong Kong', profileAnswerOptionId: 65},
	{profileAnswerOptionValue: 'Hungary', profileAnswerOptionId: 66},
	{profileAnswerOptionValue: 'Iceland', profileAnswerOptionId: 67},
	{profileAnswerOptionValue: 'India', profileAnswerOptionId: 68},
	{profileAnswerOptionValue: 'Indonesia', profileAnswerOptionId: 69},
	{profileAnswerOptionValue: 'Iraq', profileAnswerOptionId: 70},
	{profileAnswerOptionValue: 'Ireland', profileAnswerOptionId: 71},
	{profileAnswerOptionValue: 'Isle of Man', profileAnswerOptionId: 72},
	{profileAnswerOptionValue: 'Israel', profileAnswerOptionId: 73},
	{profileAnswerOptionValue: 'Italy', profileAnswerOptionId: 74},
	{profileAnswerOptionValue: 'Ivory Coast', profileAnswerOptionId: 75},
	{profileAnswerOptionValue: 'Jamaica', profileAnswerOptionId: 76},
	{profileAnswerOptionValue: 'Japan', profileAnswerOptionId: 77},
	{profileAnswerOptionValue: 'Jersey', profileAnswerOptionId: 78},
	{profileAnswerOptionValue: 'Jordan', profileAnswerOptionId: 79},
	{profileAnswerOptionValue: 'Kazakhstan', profileAnswerOptionId: 80},
	{profileAnswerOptionValue: 'Kenya', profileAnswerOptionId: 81},
	{profileAnswerOptionValue: 'Korea,Republic of', profileAnswerOptionId: 82},
	{profileAnswerOptionValue: 'Kuwait', profileAnswerOptionId: 83},
	{profileAnswerOptionValue: 'Latvia', profileAnswerOptionId: 84},
	{profileAnswerOptionValue: 'Lebanon', profileAnswerOptionId: 85},
	{profileAnswerOptionValue: 'Libya', profileAnswerOptionId: 86},
	{profileAnswerOptionValue: 'Liechtenstein', profileAnswerOptionId: 87},
	{profileAnswerOptionValue: 'Lithuania', profileAnswerOptionId: 88},
	{profileAnswerOptionValue: 'Luxembourg', profileAnswerOptionId: 89},
	{profileAnswerOptionValue: 'Macedonia,the Former Yugoslav Republic of', profileAnswerOptionId: 90},
	{profileAnswerOptionValue: 'Madagascar', profileAnswerOptionId: 91},
	{profileAnswerOptionValue: 'Malawi', profileAnswerOptionId: 92},
	{profileAnswerOptionValue: 'Malaysia', profileAnswerOptionId: 93},
	{profileAnswerOptionValue: 'Maldives', profileAnswerOptionId: 94},
	{profileAnswerOptionValue: 'Malta', profileAnswerOptionId: 95},
	{profileAnswerOptionValue: 'Mauritius', profileAnswerOptionId: 96},
	{profileAnswerOptionValue: 'Mexico', profileAnswerOptionId: 97},
	{profileAnswerOptionValue: 'Moldova', profileAnswerOptionId: 98},
	{profileAnswerOptionValue: 'Monaco', profileAnswerOptionId: 99},
	{profileAnswerOptionValue: 'Mongolia', profileAnswerOptionId: 100},
	{profileAnswerOptionValue: 'Montenegro', profileAnswerOptionId: 101},
	{profileAnswerOptionValue: 'Morocco', profileAnswerOptionId: 102},
	{profileAnswerOptionValue: 'Mozambique', profileAnswerOptionId: 103},
	{profileAnswerOptionValue: 'Myanmar', profileAnswerOptionId: 104},
	{profileAnswerOptionValue: 'Namibia', profileAnswerOptionId: 105},
	{profileAnswerOptionValue: 'Netherlands', profileAnswerOptionId: 106},
	{profileAnswerOptionValue: 'New Zealand', profileAnswerOptionId: 107},
	{profileAnswerOptionValue: 'Nicaragua', profileAnswerOptionId: 108},
	{profileAnswerOptionValue: 'Nigeria', profileAnswerOptionId: 109},
	{profileAnswerOptionValue: 'Northern Mariana Islands', profileAnswerOptionId: 110},
	{profileAnswerOptionValue: 'Norway', profileAnswerOptionId: 111},
	{profileAnswerOptionValue: 'Oman', profileAnswerOptionId: 112},
	{profileAnswerOptionValue: 'Pakistan', profileAnswerOptionId: 113},
	{profileAnswerOptionValue: 'Palestinian Authority', profileAnswerOptionId: 114},
	{profileAnswerOptionValue: 'Panama', profileAnswerOptionId: 115},
	{profileAnswerOptionValue: 'Papua New Guinea', profileAnswerOptionId: 116},
	{profileAnswerOptionValue: 'Paraguay', profileAnswerOptionId: 117},
	{profileAnswerOptionValue: 'Peru', profileAnswerOptionId: 118},
	{profileAnswerOptionValue: 'Philippines', profileAnswerOptionId: 119},
	{profileAnswerOptionValue: 'Poland', profileAnswerOptionId: 120},
	{profileAnswerOptionValue: 'Portugal', profileAnswerOptionId: 121},
	{profileAnswerOptionValue: 'Qatar', profileAnswerOptionId: 122},
	{profileAnswerOptionValue: 'Romania', profileAnswerOptionId: 123},
	{profileAnswerOptionValue: 'Russia', profileAnswerOptionId: 124},
	{profileAnswerOptionValue: 'Rwanda', profileAnswerOptionId: 125},
	{profileAnswerOptionValue: 'Saudi Arabia', profileAnswerOptionId: 126},
	{profileAnswerOptionValue: 'Senegal', profileAnswerOptionId: 127},
	{profileAnswerOptionValue: 'Serbia', profileAnswerOptionId: 128},
	{profileAnswerOptionValue: 'Seychelles', profileAnswerOptionId: 129},
	{profileAnswerOptionValue: 'Singapore', profileAnswerOptionId: 130},
	{profileAnswerOptionValue: 'Slovakia', profileAnswerOptionId: 131},
	{profileAnswerOptionValue: 'Slovenia', profileAnswerOptionId: 132},
	{profileAnswerOptionValue: 'South Africa', profileAnswerOptionId: 133},
	{profileAnswerOptionValue: 'Spain', profileAnswerOptionId: 134},
	{profileAnswerOptionValue: 'Sri Lanka', profileAnswerOptionId: 135},
	{profileAnswerOptionValue: 'Sweden', profileAnswerOptionId: 136},
	{profileAnswerOptionValue: 'Switzerland', profileAnswerOptionId: 137},
	{profileAnswerOptionValue: 'Syria', profileAnswerOptionId: 138},
	{profileAnswerOptionValue: 'Taiwan', profileAnswerOptionId: 139},
	{profileAnswerOptionValue: 'Tanzania', profileAnswerOptionId: 140},
	{profileAnswerOptionValue: 'Thailand', profileAnswerOptionId: 141},
	{profileAnswerOptionValue: 'Trinidad and Tobago', profileAnswerOptionId: 142},
	{profileAnswerOptionValue: 'Tunisia', profileAnswerOptionId: 143},
	{profileAnswerOptionValue: 'Turkey', profileAnswerOptionId: 144},
	{profileAnswerOptionValue: 'Uganda', profileAnswerOptionId: 145},
	{profileAnswerOptionValue: 'Ukraine', profileAnswerOptionId: 146},
	{profileAnswerOptionValue: 'United Arab Emirates', profileAnswerOptionId: 147},
	{profileAnswerOptionValue: 'United Kingdom', profileAnswerOptionId: 148},
	{profileAnswerOptionValue: 'United States', profileAnswerOptionId: 149},
	{profileAnswerOptionValue: 'Uruguay', profileAnswerOptionId: 150},
	{profileAnswerOptionValue: 'US Virgin Islands', profileAnswerOptionId: 151},
	{profileAnswerOptionValue: 'Uzbekistan', profileAnswerOptionId: 152},
	{profileAnswerOptionValue: 'Venezuela', profileAnswerOptionId: 153},
	{profileAnswerOptionValue: 'Vietnam', profileAnswerOptionId: 154},
	{profileAnswerOptionValue: 'Zambia', profileAnswerOptionId: 155},
	{profileAnswerOptionValue: 'Zimbabwe', profileAnswerOptionId: 156},
	{profileAnswerOptionValue: 'Other', profileAnswerOptionId: 157},
	{profileAnswerOptionValue: 'Gibraltar', profileAnswerOptionId: 333},
	{profileAnswerOptionValue: 'South Sudan', profileAnswerOptionId: 345},
	{profileAnswerOptionValue: 'Guyana', profileAnswerOptionId: 346}
];

export const projectSessionKeys = {
	projectdetail: 'projectdetail',
	milestones: 'milestone',
	groupAuditSession: 'groupAuditSession',
	projectManagementSession: 'projectManagementSession',
	insightSession: 'insightSession',
	reportingSession: 'reportingSession',
	ccpdetailSession: 'ccpdetailSession',
	projectID: 'projectID',
	userColumns: 'userColumns',
	sidebarCollapsed: 'sidebarCollapsed'
};

export const userRolesType = {
	owner: 1,
	admin: 2,
	teammember: 3
};

export const timezones = [
	{id: 'Hawaiian Standard Time', timezone: -10},
	{id: 'Alaskan Standard Time', timezone: -9},
	{id: 'Pacific Standard Time (Mexico)', timezone: -8},
	{id: 'Pacific Standard Time', timezone: -8},
	{id: 'US Mountain Standard Time', timezone: -7},
	{id: 'Mountain Standard Time (Mexico)', timezone: -7},
	{id: 'Mountain Standard Time', timezone: -7},
	{id: 'Central America Standard Time', timezone: -6},
	{id: 'Central Standard Time', timezone: -6},
	{id: 'Central Standard Time (Mexico)', timezone: -6},
	{id: 'Canada Central Standard Time', timezone: -6},
	{id: 'SA Pacific Standard Time', timezone: -5},
	{id: 'Eastern Standard Time (Mexico)', timezone: -5},
	{id: 'Eastern Standard Time', timezone: -5},
	{id: 'US Eastern Standard Time', timezone: -5},
	{id: 'Venezuela Standard Time', timezone: -4.5},
	{id: 'Paraguay Standard Time', timezone: -4},
	{id: 'Atlantic Standard Time', timezone: -4},
	{id: 'Central Brazilian Standard Time', timezone: -4},
	{id: 'SA Western Standard Time', timezone: -4},
	{id: 'Newfoundland Standard Time', timezone: -3.5},
	{id: 'E. South America Standard Time', timezone: -3},
	{id: 'Argentina Standard Time', timezone: -3},
	{id: 'SA Eastern Standard Time', timezone: -3},
	{id: 'Greenland Standard Time', timezone: -3},
	{id: 'Montevideo Standard Time', timezone: -3},
	{id: 'Bahia Standard Time', timezone: -3},
	{id: 'Pacific SA Standard Time', timezone: -3},
	{id: 'UTC-02', timezone: -2},
	{id: 'Mid-Atlantic Standard Time', timezone: -2},
	{id: 'Azores Standard Time', timezone: -1},
	{id: 'Cape Verde Standard Time', timezone: -1},
	{id: 'Morocco Standard Time', timezone: 50},
	{id: 'UTC', timezone: 0},
	{id: 'GMT Standard Time', timezone: 0},
	{id: 'Greenwich Standard Time', timezone: 0},
	{id: 'W. Europe Standard Time', timezone: 1},
	{id: 'Central Europe Standard Time', timezone: 1},
	{id: 'Romance Standard Time', timezone: 1},
	{id: 'Central European Standard Time', timezone: 1},
	{id: 'W. Central Africa Standard Time', timezone: 1},
	{id: 'Namibia Standard Time', timezone: 1},
	{id: 'Jordan Standard Time', timezone: 2},
	{id: 'GTB Standard Time', timezone: 2},
	{id: 'Middle East Standard Time', timezone: 2},
	{id: 'Egypt Standard Time', timezone: 2},
	{id: 'Syria Standard Time', timezone: 2},
	{id: 'E. Europe Standard Time', timezone: 2},
	{id: 'South Africa Standard Time', timezone: 2},
	{id: 'FLE Standard Time', timezone: 2},
	{id: 'Turkey Standard Time', timezone: 2},
	{id: 'Israel Standard Time', timezone: 2},
	{id: 'Kaliningrad Standard Time', timezone: 2},
	{id: 'Libya Standard Time', timezone: 2},
	{id: 'Arabic Standard Time', timezone: 3},
	{id: 'Arab Standard Time', timezone: 3},
	{id: 'Belarus Standard Time', timezone: 3},
	{id: 'Russian Standard Time', timezone: 3},
	{id: 'E. Africa Standard Time', timezone: 3},
	{id: 'Iran Standard Time', timezone: 3.5},
	{id: 'Arabian Standard Time', timezone: 4},
	{id: 'Azerbaijan Standard Time', timezone: 4},
	{id: 'Russia Time Zone 3', timezone: 4},
	{id: 'Mauritius Standard Time', timezone: 4},
	{id: 'Georgian Standard Time', timezone: 4},
	{id: 'Caucasus Standard Time', timezone: 4},
	{id: 'Afghanistan Standard Time', timezone: 4.5},
	{id: 'West Asia Standard Time', timezone: 5},
	{id: 'Ekaterinburg Standard Time', timezone: 5},
	{id: 'Pakistan Standard Time', timezone: 5},
	{id: 'India Standard Time', timezone: 5.5},
	{id: 'Sri Lanka Standard Time', timezone: 5.5},
	{id: 'Nepal Standard Time', timezone: 5.75},
	{id: 'Central Asia Standard Time', timezone: 6},
	{id: 'Bangladesh Standard Time', timezone: 6},
	{id: 'N. Central Asia Standard Time', timezone: 6},
	{id: 'Myanmar Standard Time', timezone: 6.5},
	{id: 'SE Asia Standard Time', timezone: 7},
	{id: 'North Asia Standard Time', timezone: 7},
	{id: 'China Standard Time', timezone: 8},
	{id: 'North Asia East Standard Time', timezone: 8},
	{id: 'Singapore Standard Time', timezone: 8},
	{id: 'W. Australia Standard Time', timezone: 8},
	{id: 'Taipei Standard Time', timezone: 8},
	{id: 'Ulaanbaatar Standard Time', timezone: 8},
	{id: 'Tokyo Standard Time', timezone: 9},
	{id: 'Korea Standard Time', timezone: 9},
	{id: 'Yakutsk Standard Time', timezone: 9},
	{id: 'Cen. Australia Standard Time', timezone: 9.5},
	{id: 'AUS Central Standard Time', timezone: 9.5},
	{id: 'E. Australia Standard Time', timezone: 10},
	{id: 'AUS Eastern Standard Time', timezone: 10},
	{id: 'West Pacific Standard Time', timezone: 10},
	{id: 'Tasmania Standard Time', timezone: 10},
	{id: 'Magadan Standard Time', timezone: 10},
	{id: 'Vladivostok Standard Time', timezone: 10},
	{id: 'Russia Time Zone 10', timezone: 11},
	{id: 'Central Pacific Standard Time', timezone: 11},
	{id: 'Russia Time Zone 11', timezone: 12},
	{id: 'New Zealand Standard Time', timezone: 12},
	{id: 'UTC+12', timezone: 12},
	{id: 'Fiji Standard Time', timezone: 12},
	{id: 'Kamchatka Standard Time', timezone: 12},
	{id: 'Tonga Standard Time', timezone: 13},
	{id: 'Samoa Standard Time', timezone: 13},
	{id: 'Line Islands Standard Time', timezone: 13}
];

export const countries = [
	{name: 'Afghanistan', code: 'AF'},
	{name: 'Aland Islands', code: 'AX'},
	{name: 'Algeria', code: 'DZ'},
	{name: 'Albania', code: 'AL'},
	{name: 'American Samoa', code: 'AS'},
	{name: 'Andorra', code: 'AD'},
	{name: 'Angola', code: 'AO'},
	{name: 'Anguilla', code: 'AI'},
	{name: 'Antarctica', code: 'AQ'},
	{name: 'Antigua and Barbuda', code: 'AG'},
	{name: 'Argentina', code: 'AR'},
	{name: 'Armenia', code: 'AM'},
	{name: 'Armenia-RussiaDC', code: 'AM'},
	{name: 'Aruba', code: 'AW'},
	{name: 'Australia', code: 'AU'},
	{name: 'Austria', code: 'AT'},
	{name: 'Azerbaijan', code: 'AZ'},
	{name: 'Bahamas', code: 'BS'},
	{name: 'Bahrain', code: 'BH'},
	{name: 'Bangladesh', code: 'BD'},
	{name: 'Barbados', code: 'BB'},
	{name: 'Belarus', code: 'BY'},
	{name: 'Belarus-RussiaDC', code: 'BY'},
	{name: 'Belgium', code: 'BE'},
	{name: 'Belize', code: 'BZ'},
	{name: 'Benin', code: 'BJ'},
	{name: 'Bermuda', code: 'BM'},
	{name: 'Bhutan', code: 'BT'},
	{name: 'Bolivia', code: 'BO'},
	{name: 'Bosnia and Herzegovina', code: 'BA'},
	{name: 'Botswana', code: 'BW'},
	{name: 'Bouvet Island', code: 'BV'},
	{name: 'Brazil', code: 'BR'},
	{name: 'British Indian Ocean Territory', code: 'IO'},
	{name: 'British Virgin Islands', code: 'VG'},
	{name: 'Brunei', code: 'BN'},
	{name: 'Bulgaria', code: 'BG'},
	{name: 'Burkina Faso', code: 'BF'},
	{name: 'Burundi', code: 'BI'},
	{name: 'Cambodia', code: 'KH'},
	{name: 'Cameroon', code: 'CM'},
	{name: 'Canada', code: 'CA'},
	{name: 'Cape Verde', code: 'CV'},
	{name: 'Cayman Islands', code: 'KY'},
	{name: 'Central African Republic', code: 'CF'},
	{name: 'Chad', code: 'TD'},
	{name: 'Chile', code: 'CL'},
	{name: 'China', code: 'CN'},
	{name: 'Christmas Island', code: 'CX'},
	{name: 'Cocos (Keeling) Islands', code: 'CC'},
	{name: 'Colombia', code: 'CO'},
	{name: 'Comoros', code: 'KM'},
	{name: 'Congo', code: 'CG'},
	{name: 'Congo, The Democratic Republic of the', code: 'CD'},
	{name: 'Cook Islands', code: 'CK'},
	{name: 'Costa Rica', code: 'CR'},
	{name: 'Croatia', code: 'HR'},
	{name: 'Cuba', code: 'CU'},
	{name: 'Cyprus', code: 'CY'},
	{name: 'Czech Republic', code: 'CZ'},
	{name: 'Denmark', code: 'DK'},
	{name: 'Djibouti', code: 'DJ'},
	{name: 'Dominica', code: 'DM'},
	{name: 'Dominican Republic', code: 'DO'},
	{name: 'East Timor', code: 'TL'},
	{name: 'Ecuador', code: 'EC'},
	{name: 'Egypt', code: 'EG'},
	{name: 'El Salvador', code: 'SV'},
	{name: 'Equatorial Guinea', code: 'GQ'},
	{name: 'Eritrea', code: 'ER'},
	{name: 'Estonia', code: 'EE'},
	{name: 'Ethiopia', code: 'ET'},
	{name: 'Falkland Islands (Malvinas)', code: 'FK'},
	{name: 'Faroe Islands', code: 'FO'},
	{name: 'Fiji', code: 'FJ'},
	{name: 'Finland', code: 'FI'},
	{name: 'France', code: 'FR'},
	{name: 'French Guiana', code: 'GF'},
	{name: 'French Polynesia', code: 'PF'},
	{name: 'French Southern Territories', code: 'TF'},
	{name: 'Gabon', code: 'GA'},
	{name: 'Gambia', code: 'GM'},
	{name: 'Georgia', code: 'GE'},
	{name: 'Germany', code: 'DE'},
	{name: 'Ghana', code: 'GH'},
	{name: 'Gibraltar', code: 'GI'},
	{name: 'Greece', code: 'GR'},
	{name: 'Greenland', code: 'GL'},
	{name: 'Grenada', code: 'GD'},
	{name: 'Guadeloupe', code: 'GP'},
	{name: 'Guam', code: 'GU'},
	{name: 'Guatemala', code: 'GT'},
	{name: 'Guernsey', code: 'GG'},
	{name: 'Guinea', code: 'GN'},
	{name: 'Guinea-Bissau', code: 'GW'},
	{name: 'Guyana', code: 'GY'},
	{name: 'Haiti', code: 'HT'},
	{name: 'Heard and McDonald Islands', code: 'HM'},
	{name: 'Honduras', code: 'HN'},
	{name: 'Hong Kong', code: 'HK'},
	{name: 'Hungary', code: 'HU'},
	{name: 'Iceland', code: 'IS'},
	{name: 'India', code: 'IN'},
	{name: 'Indonesia', code: 'ID'},
	{name: 'Iran', code: 'IR'},
	{name: 'Iraq', code: 'IQ'},
	{name: 'Ireland', code: 'IE'},
	{name: 'Isle of Man', code: 'IM'},
	{name: 'Israel', code: 'IL'},
	{name: 'Italy', code: 'IT'},
	{name: 'Ivory Coast', code: 'CI'},
	{name: 'Jamaica', code: 'JM'},
	{name: 'Japan', code: 'JP'},
	{name: 'Jersey', code: 'JE'},
	{name: 'Jordan', code: 'JO'},
	{name: 'Kazakhstan', code: 'KZ'},
	{name: 'Kenya', code: 'KE'},
	{name: 'Kiribati', code: 'KI'},
	{name: "Korea, Democratic People's Republic of", code: 'KP'},
	{name: 'Korea, Republic of', code: 'KR'},
	{name: 'Kosovo', code: 'TT'},
	{name: 'Kuwait', code: 'KW'},
	{name: 'Kyrgyzstan', code: 'KG'},
	{name: 'Laos', code: 'LA'},
	{name: 'Latvia', code: 'LV'},
	{name: 'Lebanon', code: 'LB'},
	{name: 'Lesotho', code: 'LS'},
	{name: 'Liberia', code: 'LR'},
	{name: 'Libya', code: 'LY'},
	{name: 'Liechtenstein', code: 'LI'},
	{name: 'Lithuania', code: 'LT'},
	{name: 'Luxembourg', code: 'LU'},
	{name: 'Macao', code: 'MO'},
	{name: 'North Macedonia', code: 'MK'},
	{name: 'Madagascar', code: 'MG'},
	{name: 'Malawi', code: 'MW'},
	{name: 'Malaysia', code: 'MY'},
	{name: 'Maldives', code: 'MV'},
	{name: 'Mali', code: 'ML'},
	{name: 'Malta', code: 'MT'},
	{name: 'Marshall Islands', code: 'MH'},
	{name: 'Martinique', code: 'MQ'},
	{name: 'Mauritania', code: 'MR'},
	{name: 'Mauritius', code: 'MU'},
	{name: 'Mayotte', code: 'YT'},
	{name: 'Mexico', code: 'MX'},
	{name: 'Micronesia, Federated States of', code: 'FM'},
	{name: 'Moldova', code: 'MD'},
	{name: 'Monaco', code: 'MC'},
	{name: 'Mongolia', code: 'MN'},
	{name: 'Montenegro', code: 'ME'},
	{name: 'Montserrat', code: 'MS'},
	{name: 'Morocco', code: 'MA'},
	{name: 'Mozambique', code: 'MZ'},
	{name: 'Myanmar', code: 'MM'},
	{name: 'Namibia', code: 'NA'},
	{name: 'Nauru', code: 'NR'},
	{name: 'Nepal', code: 'NP'},
	{name: 'Netherlands', code: 'NL'},
	{name: 'New Caledonia', code: 'NC'},
	{name: 'New Zealand', code: 'NZ'},
	{name: 'Nicaragua', code: 'NI'},
	{name: 'Niger', code: 'NE'},
	{name: 'Nigeria', code: 'NG'},
	{name: 'Niue', code: 'NU'},
	{name: 'Norfolk Islands', code: 'NF'},
	{name: 'Northern Mariana Islands', code: 'MP'},
	{name: 'Norway', code: 'NO'},
	{name: 'Oman', code: 'OM'},
	{name: 'Pakistan', code: 'PK'},
	{name: 'Palau', code: 'PW'},
	{name: 'Palestinian Authority', code: 'PS'},
	{name: 'Papua New Guinea', code: 'PG'},
	{name: 'Paraguay', code: 'PY'},
	{name: 'Peru', code: 'PE'},
	{name: 'Philippines', code: 'PH'},
	{name: 'Pitcairn', code: 'PN'},
	{name: 'Poland', code: 'PL'},
	{name: 'Portugal', code: 'PT'},
	{name: 'Puerto Rico', code: 'PR'},
	{name: 'Qatar', code: 'QA'},
	{name: 'Reunion', code: 'RE'},
	{name: 'Romania', code: 'RO'},
	{name: 'Russia Other Legal Entities', code: 'RU'},
	{name: 'Rwanda', code: 'RW'},
	{name: 'Russia OOO EY & OOO EY Vneshaudit', code: 'RU'},
	{name: 'Saint Helena', code: 'SH'},
	{name: 'Saint Kitts and Nevis', code: 'KN'},
	{name: 'Saint Lucia', code: 'LC'},
	{name: 'Saint Pierre and Miquelon', code: 'PM'},
	{name: 'Saint Vincent and the Grenadines', code: 'VC'},
	{name: 'Samoa', code: 'WS'},
	{name: 'San Marino', code: 'SM'},
	{name: 'Sao Tome and Principe', code: 'ST'},
	{name: 'Saudi Arabia', code: 'SA'},
	{name: 'Senegal', code: 'SN'},
	{name: 'Serbia', code: 'RS'},
	{name: 'Seychelles', code: 'SC'},
	{name: 'Sierra Leone', code: 'SL'},
	{name: 'Singapore', code: 'SG'},
	{name: 'Slovakia', code: 'SK'},
	{name: 'Slovenia', code: 'SI'},
	{name: 'Solomon Islands', code: 'SB'},
	{name: 'Somalia', code: 'SO'},
	{name: 'South Africa', code: 'ZA'},
	{name: 'South Georgia and the South Sandwich Islands', code: 'GS'},
	{name: 'South Sudan', code: 'SS'},
	{name: 'Spain', code: 'ES'},
	{name: 'Sri Lanka', code: 'LK'},
	{name: 'Suriname', code: 'SR'},
	{name: 'Svalbard and Jan Mayen', code: 'SJ'},
	{name: 'Swaziland', code: 'SZ'},
	{name: 'Sweden', code: 'SE'},
	{name: 'Switzerland', code: 'CH'},
	{name: 'Syria', code: 'SY'},
	{name: 'Taiwan', code: 'TW'},
	{name: 'Tajikistan', code: 'TJ'},
	{name: 'Tanzania', code: 'TZ'},
	{name: 'Thailand', code: 'TH'},
	{name: 'Togo', code: 'TG'},
	{name: 'Tokelau', code: 'TK'},
	{name: 'Tonga', code: 'TO'},
	{name: 'Trinidad and Tobago', code: 'TT'},
	{name: 'Tunisia', code: 'TN'},
	{name: 'Turkey', code: 'TR'},
	{name: 'Turkmenistan', code: 'TM'},
	{name: 'Turks and Caicos Islands', code: 'TC'},
	{name: 'Tuvalu', code: 'TV'},
	{name: 'Uganda', code: 'UG'},
	{name: 'Ukraine', code: 'UA'},
	{name: 'United Arab Emirates', code: 'AE'},
	{name: 'United Kingdom', code: 'GB'},
	{name: 'United States', code: 'US'},
	{name: 'United States - Government', code: 'US'},
	{name: 'Uruguay', code: 'UY'},
	{name: 'US Minor Outlying Islands', code: 'UM'},
	{name: 'US Virgin Islands', code: 'VI'},
	{name: 'Uzbekistan', code: 'UZ'},
	{name: 'Uzbekistan-RussiaDC', code: 'UZ'},
	{name: 'Vanuatu', code: 'VU'},
	{name: 'Vatican City State', code: 'VA'},
	{name: 'Venezuela', code: 'VE'},
	{name: 'Vietnam', code: 'VN'},
	{name: 'Wallis and Futuna', code: 'WF'},
	{name: 'Western Sahara', code: 'EH'},
	{name: 'Yemen', code: 'YE'},
	{name: 'Zambia', code: 'ZM'},
	{name: 'Zimbabwe', code: 'ZW'}
];

export const natureOfEngagements = {
	auditStatements: {id: 1, order: 1},
	reviewStatements: {id: 313, order: 3},
	integratedStatements: {id: 314, order: 2},
	nonAuditAccount: {id: 338, order: 4},
	nonAuditWorkPlan: {id: 339, order: 5}
};

export const projectRoutes = {
	contacts: 'Contacts',
	entities: 'Entities',
	filters: 'Filters'
};

export const ContactsDBFilterTypeQuery = {
	byEngagement: 'contactsbyengagement',
	byCountry: 'contactsbycountry',
	byTag: 'contactsbytag',
	byGroupRole: 'contactsbygrouprole',
	byServiceLine: 'contactsbyserviceline',
	byRole: 'contactsbyrole',
	byType: 'type',
	byContactList: 'contactlist',
	byDashboardAccess: 'dashboardaccess',
	byGroupAccess: 'groupaccess'
};

export const MessageLogFilterTypeQuery = {
	byMessageType: 'messageLogByMessageType',
	bySentBy: 'messageLogBySentBy',
	byFromEntity: 'messageLogByFromEntity',
	byToEntity: 'messageLogByToEntity',
	byToCountry: 'messageLogByToCountry',
	byToGroupRole: 'messageLogByToGroupRole',
	byToEngagement: 'messageLogByToEngagement',
	byToServiceLine: 'messageLogByToServiceLine',
	byToRole: 'messageLogByToRole'
};

export const routeToRedirectEditProject = {
	editProject: 'projects/project?projectId={projectId}&step=2',
	contactsUrl: 'contacts',
	dashboardUrl: 'dashboard',
	contacts: '/contacts?projectId=',
	dashbaord: '/dashboard?projectId=',
	home: '/projects'
};

export const SendEmailVars = {
	entities: 'entities'
};

export const contactListColumnIds = {
	basicName: 'basicNameColumn',
	name: 'nameProfileColumn',
	engagements: 'engagementsColumn',
	serviceLine: 'serviceLineColumn',
	role: 'roleColumn',
	dashboard: 'dashboardColumn',
	groupRiskAssessment: 'groupRiskAssessmentColumn',
	contactList: 'contactListColumn',
	tags: 'tagsColumn',
	isInternal: 'isInternalColumn',
	entities: 'entitiesColumn',
	delete: 'deleteColumn'
};

export const StandardColumns = {
	columns: [
		{
			id: 1,
			label: 'Engagements',
			labels: 'columnEngagement',
			title: 'Engagements',
			isChecked: true,
			propName: 'eng',
			customSort: {
				iteratee: ['engagements', 'name', 'lastName'],
				innerSort: [{parentField: 'engagements', childField: 'description'}]
			},
			customCellRender: (item) => renderEngagements(item),
			columnId: contactListColumnIds.engagements
		},
		{
			id: 2,
			label: 'Service line',
			labels: 'columnServiceLine',
			title: 'Service line',
			isChecked: true,
			propName: 'svcLine',
			customSort: {
				iteratee: ['serviceLine', 'name', 'lastName']
			},
			customCellRender: (item) => renderServiceLine(item),
			columnId: contactListColumnIds.serviceLine
		},
		{
			id: 3,
			label: 'Role',
			labels: 'columnRole',
			title: 'Role',
			isChecked: true,
			propName: 'role',
			customSort: {
				iteratee: ['roleId', 'name', 'lastName']
			},
			customCellRender: (item) => renderRole(item),
			columnId: contactListColumnIds.role
		},
		{
			id: 4,
			label: 'Access to Dashboard',
			labels: 'columnDashboard',
			title: 'Access to Dashboard',
			isChecked: true,
			propName: 'dashboard',
			customSort: {
				reverseSort: true,
				iteratee: ['dashboard.length', 'name', 'lastName']
			},
			customCellRender: (item) => renderDashboard(item),
			columnId: contactListColumnIds.dashboard
		},
		{
			id: 5,
			label: 'Access to group risk assessment',
			labels: 'columnGroupRiskAssessment',
			title: 'Access to group risk assessment',
			isChecked: true,
			propName: 'groupRiskAssessment',
			customSort: {
				iteratee: ['hasGroupRiskAssessment', 'name', 'lastName']
			},
			customCellRender: (item) => rendergroupRiskAssesment(item),
			columnId: contactListColumnIds.groupRiskAssessment
		},
		{
			id: 6,
			label: 'Access to Contact list',
			labels: 'columnContactList',
			title: 'Access to Contact list',
			isChecked: true,
			propName: 'contList',
			customSort: {
				reverseSort: true,
				iteratee: ['contactList.hasAccess', 'name', 'lastName']
			},
			customCellRender: (item) => renderContactList(item),
			columnId: contactListColumnIds.contactList
		},
		{
			id: 7,
			label: 'Tags',
			labels: 'columnTags',
			title: 'Tags',
			isChecked: false,
			propName: 'tag',
			iteratee: 'hasTag',
			customCellRender: (item) => renderTagsList(item),
			columnId: contactListColumnIds.tags
		}
	]
};

export const standardColumnsExternalUser = {
	columns: [
		{
			id: 1,
			label: 'Tags',
			labels: 'columnTags',
			title: 'Tags',
			isChecked: true,
			propName: 'tag',
			iteratee: 'hasTag',
			customCellRender: (item) => renderTagsList(item),
			columnId: contactListColumnIds.tags
		},
		{
			id: 2,
			label: 'Service line',
			labels: 'columnServiceLine',
			title: 'Service line',
			isChecked: true,
			propName: 'svcLine',
			customSort: {
				iteratee: ['serviceLine', 'name', 'lastName']
			},
			customCellRender: (item) => renderServiceLine(item),
			columnId: contactListColumnIds.serviceLine
		},
		{
			id: 3,
			label: 'Role',
			labels: 'columnRole',
			title: 'Role',
			isChecked: true,
			propName: 'role',
			customSort: {
				iteratee: ['roleId', 'name', 'lastName']
			},
			customCellRender: (item) => renderRole(item),
			columnId: contactListColumnIds.role
		},
		{
			id: 4,
			label: 'Engagements',
			labels: 'columnEngagement',
			title: 'Engagements',
			isChecked: false,
			propName: 'eng',
			customSort: {
				iteratee: ['engagements', 'name', 'lastName'],
				innerSort: [{parentField: 'engagements', childField: 'description'}]
			},
			customCellRender: (item) => renderEngagements(item),
			columnId: contactListColumnIds.engagements
		},
		{
			id: 5,
			label: 'Access to Dashboard',
			labels: 'columnDashboard',
			title: 'Access to Dashboard',
			isChecked: false,
			propName: 'dashboard',
			customSort: {
				reverseSort: true,
				iteratee: ['dashboard.length', 'name', 'lastName']
			},
			customCellRender: (item) => renderDashboard(item),
			columnId: contactListColumnIds.dashboard
		},
		{
			id: 6,
			label: 'Access to group risk assessment',
			labels: 'columnGroupRiskAssessment',
			title: 'Access to group risk assessment',
			isChecked: true,
			propName: 'groupRiskAssessment',
			customSort: {
				reverseSort: true,
				iteratee: ['hasGroupRiskAssessment', 'name', 'lastName']
			},
			customCellRender: (item) => rendergroupRiskAssesment(item),
			columnId: contactListColumnIds.groupRiskAssessment
		},
		{
			id: 7,
			label: 'Access to Contact list',
			labels: 'columnContactList',
			title: 'Access to Contact list',
			isChecked: false,
			propName: 'contList',
			customSort: {
				reverseSort: true,
				iteratee: ['contactList.hasAccess', 'name', 'lastName']
			},
			customCellRender: (item) => renderContactList(item),
			columnId: contactListColumnIds.contactList
		}
	]
};

export const scrollableColumns = 3;

export const MSGraphURL =
	'https://graph.microsoft.com/v1.0/me/people?$search=%22{0}@ey.com%22&$top=1&$filter=personType/class%20eq%20%27Person%27';

export const entityParamFromUrl = {
	entityId: '/Entities/'
};
export const addContactConstants = {
	isChecked: 'isChecked',
	member: 'Member',
	contacts: 'contacts',
	dashboardViews: 'dashboardViews',
	serviceLine: 'serviceLine',
	rank: 'rank',
	phone: 'phone',
	location: 'Location',
	hasViews: 'hasViews',
	tags: 'tags',
	customColumns: 'customColumns',
	contactList: 'contactList',
	dashboardProp: 'dashboard',
	engagements: 'engagements',
	groupRiskAssessment: 'groupRiskAssessment',
	userLevelAccess: 'userLevelAccess'
};

export const addContactRestricted = {
	Insights: dashboardTabId.insights,
	projectManagement: dashboardTabId.projectManagement
};

export const contactDBRoutes = {
	projects: 'Projects',
	messages: 'Messages',
	countries: 'Countries',
	potentialContactacts: 'PotentialContacts',
	entities: 'Entities',
	tags: 'Tags',
	tagContacts: 'TagContacts',
	contactsDelete: 'BulkContactDeletes',
	contactProperties: 'ContactProperties'
};

export const exportContacts = {
	entityName: 'entityName',
	name: 'name',
	email: 'email',
	engagements: 'engagements',
	serviceLine: 'serviceLine',
	role: 'role',
	accessDashboard: 'accessDashboard',
	dashboardViews: 'dashboardViews',
	accessContactlist: 'accessContactlist',
	tags: 'tags'
};

export const exportMessageLogs = {
	type: 'type',
	sentBy: 'sentBy',
	from: 'from',
	date: 'date',
	time: 'time',
	subject: 'subject',
	contacts: 'contacts'
};

export const accessLogOptions = {
	contactsToAdd: 1,
	contactsToRemove: 2
};

export const contactPropertiesOperation = {
	addTag: 0,
	removeTag: 1,
	addCustomColumn: 2,
	removeCustomColumn: 3
};

export const addContactsTabs = {
	access: 1,
	attributes: 2,
	tags: 3
};

export const milestonesAccessViewRoles = ['Milestones', 'milestones view role', 'All'];
export const projectManagementAccessViewRoles = ['Project management', 'project management view role', 'All'];
export const groupAuditAccessViewRoles = ['group audit view role', 'All'];
export const insightAccessViewRoles = ['Insights', 'audit insight view role', 'All'];
export const reportingAccessViewRoles = ['Reporting', 'reporting view role', 'All'];
export const ccpAccessViewRoles = [
	'EY Canvas Client Portal',
	'Canvas Client Portal',
	'canvas client portal view role',
	'All'
];
export const dashboardAccessViewRoles = [
	...milestonesAccessViewRoles,
	...projectManagementAccessViewRoles,
	...groupAuditAccessViewRoles,
	...insightAccessViewRoles,
	...reportingAccessViewRoles,
	...ccpAccessViewRoles
];
export const groupRiskAssessmentAccessViewRoles = ['group risk assessment view role', 'All'];
export const contactListAccessViewRoles = ['Contacts', 'contacts view role', 'All'];

export const concurrencyErrorCode = '346';
export const inventedConcurrencyErrorCode = '399';

export const anotherAdministratorAlreadyReviewedAccessForUserErrorCode = '346';
export const newAnotherAdministratorAlreadyReviewedAccessForUserErrorCode = '394';

export const userDoesNotHavePermissionOnAllEntitiesErrorCode = '348';
export const newUserDoesNotHavePermissionOnAllEntitiesErrorCode = '398';
export const cannotRemovePOWithNonPOUser = '376';

export const userIsNotEntityAdminOfAllSelectedEntitiesErrorCode = '362';
export const newUserIsNotEntityAdminOfAllSelectedEntitiesErrorCode = '397';

export const userIsNotEntityAdminOfAllSelectedEntitiesErrorCodeCustomAttributes = '366';
export const newUserIsNotEntityAdminOfAllSelectedEntitiesErrorCodeCustomAttributes = '396';

export const contactHasBeenDeletedErrorCodeCustomAttributes = '365';
export const newContactHasBeenDeletedErrorCodeCustomAttributes = '395';

export const userIsNotEntityAdminOfAllSelectedEntitiesErrorCodeCustomAttributesContacts = '370';
export const newUserIsNotEntityAdminOfAllSelectedEntitiesErrorCodeCustomAttributesContacts = '397';

export const fontSizeMapping = {
	S: {fontSize: 10, lineHeight: 16},
	M: {fontSize: 12, lineHeight: 20},
	L: {fontSize: 14, lineHeight: 20},
	XL: {fontSize: 16, lineHeight: 22},
	XXL: {fontSize: 20, lineHeight: 24}
};
export const fontWeightMapping = {
	lighter: 100,
	light: 300,
	normal: 400,
	bold: 600
};
export const colorArray = [
	'Maroon100',
	'Maroon200',
	'Maroon300',
	'Maroon400',
	'Maroon500',
	'Maroon600',
	'Maroon700',
	'black',
	'blackyellow',
	'blue100',
	'blue200',
	'blue300',
	'blue400',
	'blue500',
	'blue600',
	'blue600yellow400',
	'blue700',
	'gr50black',
	'gr50grey450',
	'gr50grey600',
	'green100',
	'green200',
	'green300',
	'green400',
	'green500',
	'green600',
	'green700',
	'grey50',
	'grey100',
	'grey100blue15',
	'grey100blue500',
	'grey100grey450',
	'grey100grey550',
	'grey200',
	'grey225',
	'grey250',
	'grey300',
	'grey300black',
	'grey400',
	'grey450',
	'grey500',
	'grey500grey450',
	'grey500grey600',
	'grey550',
	'grey600',
	'orange100',
	'orange200',
	'orange300',
	'orange400',
	'orange500',
	'orange600',
	'orange700',
	'purple100',
	'purple200',
	'purple300',
	'purple400',
	'purple500',
	'purple600',
	'purple700',
	'red100',
	'red200',
	'red300',
	'red400',
	'red500',
	'red600',
	'red700',
	'teal100',
	'teal200',
	'teal300',
	'teal400',
	'teal500',
	'teal600',
	'teal700',
	'white',
	'whiteGrey200',
	'whiteGrey250',
	'whiteGrey450',
	'whiteGrey550',
	'whiteblack',
	'yellow400'
];
export const INTERNAL_COLOR = 'INTERNAL';
export const EXTERNAL_COLOR = 'EXTERNAL';
export const PO_COLOR = 'PROJECTOWNERS';
export const EA_COLOR = 'ENTITYADMINS';
export const KC_COLOR = 'KEYCONTACTS';
export const colorSchema = {
	[INTERNAL_COLOR]: 'teal',
	[EXTERNAL_COLOR]: 'maroon',
	[PO_COLOR]: 'purple',
	[EA_COLOR]: 'orange',
	[KC_COLOR]: 'blue'
};

export const toolTipNames = {
	Id: '- ID:',
	Code: '- Code:'
};

export const dashboardViews = {
	milestones: 'Milestones',
	ccp: 'Canvas Client Portal',
	groupAudit: 'Group audit',
	projectManagement: 'Project management',
	insights: 'Insights',
	reporting: 'Reporting',
	all: 'All'
};

export const groupRiskAssessment = {
	groupRiskAssessment: 'groupriskassessment'
};

export const source = {
	contactList: 0,
	accessLog: 1
};

export const maxLengthInputs = {
	projectName: 100,
	firstName: 100,
	lastName: 100,
	comment: 400,
	rationaleComment: 4000
};

export const projectKind = {
	Classic: 'Classic',
	GRA: 'GRA'
};

export const groupRiskAssessmentPropName = 'groupRiskAssessment';

export const TaskType = [
	{value: 1, taskName: 'Control Task', taskAbbr: 'TOC'},
	{value: 2, taskName: 'Control Task - Control', taskAbbr: 'TOC'},
	{value: 3, taskName: 'Control Task - ELC', taskAbbr: 'TOC'},
	{value: 4, taskName: 'Control Task - IT/SO', taskAbbr: 'TOC'},
	{value: 5, taskName: 'Control Task - MP', taskAbbr: 'TOC'},
	{value: 6, taskName: 'Control Task - SO', taskAbbr: 'TOC'},
	{value: 7, taskName: 'Response Task', taskAbbr: 'RT'},
	{value: 8, taskName: 'Cashflow Misstatement Response Task', taskAbbr: 'RT'},
	{value: 9, taskName: 'Deficiency Response Task', taskAbbr: 'RT'},
	{
		value: 10,
		taskName: 'Disclosure Misstatement Response Task',
		taskAbbr: '	RT'
	},
	{value: 11, taskName: 'Misstatement Response Task', taskAbbr: 'RT'},
	{value: 12, taskName: 'Standard Task', taskAbbr: ''},
	{value: 13, taskName: 'Other Standard Task', taskAbbr: 'OST'},
	{value: 14, taskName: 'Primary Standard Task', taskAbbr: '	PST'},
	{value: 15, taskName: 'Substantive Task', taskAbbr: ''},
	{value: 16, taskName: 'Other Substantive Procedure Task', taskAbbr: 'OSP'},
	{value: 17, taskName: 'Primary Substantive Procedure Task', taskAbbr: 'PSP'},
	{value: 18, taskName: 'Walkthrough Task', taskAbbr: 'WT'},
	{value: 19, taskName: 'Walkthrough Task - IT/SO', taskAbbr: 'WT'},
	{value: 20, taskName: 'Walkthrough Task - SCOT', taskAbbr: 'WT'},
	{value: 21, taskName: 'Todo', taskAbbr: ''},
	{value: 22, taskName: 'Account Conclusion Task', taskAbbr: 'ACT'},
	{value: 23, taskName: 'Group Task', taskAbbr: 'GT'},
	{value: 24, taskName: 'Primary Group Task', taskAbbr: 'GT'},
	{value: 25, taskName: 'Component Group Task', taskAbbr: 'GT'},
	{
		value: 26,
		taskName: 'IT/SO Other Substantive Procedure Task',
		taskAbbr: 'OSP'
	},
	{value: 27, taskName: 'Component Group Task Unlinked', taskAbbr: 'GT'}
];

export const tablePaginationSizeOptions = [20, 50, 100];

export const adobeAnalytics = {
	rootPageName: 'Dashboard'
};

export const userLevelAccess = 'userLevelAccess';

export const reconciliationsFilterIds = {
	openAccounts: 'openAccounts',
	assessedAccounts: 'assessedAccounts',
	openRisks: 'openRisks',
	assessedRisks: 'assessedRisks'
};

export const riskTypeIds = {
	significant: 1,
	fraud: 2,
	insignificant: 3
};

export const riskTypeAbbreviation = {
	[riskTypeIds.significant]: 'SR',
	[riskTypeIds.fraud]: 'FR',
	[riskTypeIds.insignificant]: 'IR'
};

export const groupRiskStatus = {
	open: 1,
	assessed: 2,
	mapped: 3,
	unmapped: 4,
	notApplicable: 5,
	systemReOpened: 6
};

export const accountTypeIds = {
	significantAccount: 1,
	limitedRiskAccount: 2,
	insignificantAccount: 3,
	accountOther: 4,
	significantDisclosure: 5
};

export const executionTypeIds = {
	executedInThisEngagement: 1,
	groupExecutedInComponentEngagement: 2,
	groupExecutedInPrimaryAndComponentEngagement: 3
};

export const jsonDocumentPatchOperations = {
	add: 'Add',
	remove: 'Remove',
	replace: 'Replace',
	copy: 'Copy',
	move: 'Move',
	test: 'Test'
};

export const componentsTabId = {
	NotRelated: 1,
	NotApplicable: 2
};

export const componentAccountsPropNames = {
	notRelated: 'notRelated',
	notApplicable: 'notApplicable'
};
